<template>
<div class="chapter">
<div class="inner_page">
<div id="FM02">
<div class="fm-center-t">“In a bleak land is not the place to enjoy solitude.”</div>
<div class="fm-center">Joshua Slocum</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_FM02.vue?5613ba80